export enum StripeProductFields {
  stripeProductId = "stripeProductId",
  name = "name",
  status = "status",
  prices = "prices",
}
